<template>
    <div>
        <el-dialog
                title="Drill down"
                :visible.sync="showDrilldownDialog">
          <p>Filter</p>
          <el-checkbox-group v-model="selected_filter_tests">
          <el-checkbox v-for="test in filter_values" :label="test.human_readable"></el-checkbox>
          </el-checkbox-group>
            <div v-if="!drilldownHierarchy">
                <p>What field do you want to drill down on?</p>
                <el-select filterable style="padding-left:10px;" v-model="drilldownPrimaryField" placeholder="Select">
                    <el-option
                            v-for="field in metadata"
                            :key="field.id"
                            :label="field.display_name"
                            :value="field.display_name">
                    </el-option>
                </el-select>
            </div>
          <p>{{drilldownText}}</p>
          <el-button @click="drillDown">Drill down
              <span v-if="drilldownHierarchy"> on hierarchy </span>
              <span v-else>                    on {{ drilldownPrimaryField }} </span>
          </el-button>
        </el-dialog>
        <el-dialog
          title="Define Rule"
          :visible.sync="showRuleDialog">
          <p>Filter</p>
          <el-checkbox v-model="test.enabled" v-for="test in filter_values">{{test.human_readable}}</el-checkbox>
          <div style="margin-top:10px;">
            <div>Bucket<el-input v-model="ruleBucket"></el-input></div>
            <div>Disposition<el-input v-model="ruleDisposition"></el-input></div>
            <div>Resourcing<el-input v-model="ruleResourcing"></el-input></div>
          </div>
          <el-checkbox v-model="ruleRerun">Run ruleset on save</el-checkbox>
          <el-button @click="saveRule" style="margin-top:20px;">Save rule</el-button>
          <p style="margin-top:20px;">{{runRuleText}}</p>
        </el-dialog>

        <el-dialog
                :title="sample_title"
                :visible.sync="show_sample_overlay">

            <TableSample
                v-bind:data="sample"
                :extent_id="extent_id"
            />

          <!--
            <el-button @click="download_selection_as_csv">Download full set as CSV</el-button>
            -->
            <el-button @click="openDrilldownDialog">Drill down</el-button>
            <el-button @click="openRuleDialog">Create rule</el-button>
        </el-dialog>
        <el-dialog
                :title="outliers_label"
                :visible.sync="show_outliers_overlay">
            <ul>
                <li v-for="(outlier, name) in outliers"><el-button style="margin-top:20px" v-on:click="show_sample(outlier.field_value)">{{outlier.field_value}}: {{outlier.count}}</el-button></li>
            </ul>
        </el-dialog>
        <div v-if="endPoint">
            <ChartManager ref="chart" :height="height" :width="width" :text_size="text_size"
                          :chart-type="chart_config.chart_type"
                          @chartError="chartError"
                          @chartClicked="show_sample($event)"
                          @stackChartClicked="show_stacked_sample($event)"
                          @barLabelClicked="show_label_info($event)"
                          @colorsLoaded="colorsLoaded($event)"
                          @dataLoaded="dataLoaded"
                          @chartMetaLoaded="chartMetaLoaded($event)"
                          :endPoint="endPoint"
                          :render_info="render_info"
                          :highlighted="highlighted"
                          :additional_filters="additional_filters"
                          :extent_id="extent_id"
                          :is_render_ready="is_render_ready"
            />
            <div v-for="(value, key, index) in assignment_summaries" v-bind:style="{ 'background-color': colors[index] }" style="padding:5px;margin:5px;text-align:center;">
                <el-button @click="show_sample(key)" type="text" style="opacity:0.6;padding-right:10px;padding-left:10px;margin:5px;background-color:white;color:black;">{{key}} ({{value}})</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        // field_name, chartType >> chart_config.chart_type, endPoint (local), config_params (local), group_field >> chart_config.group_by_field, color_field >> color_by_field, max_bars >> chart_config.max_bars
        props: ['extent_id','height','width','text_size', 'filter_name', 'chart_config','version','render_info','metadata', 'snapshotId','click_callback','sticky_click','additional_filters','set_drilldown','render_ready', 'forced'],
        mounted() {
            this.setEndPoint()
          if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
        },
        computed: {
            is_render_ready: function() {
              // intentionally using double (and not triple) equals since want either when it's null or undefined
              if (this.render_ready==null) return true;
              else return this.render_ready
            },
            runRuleText: function() {
              if (this.ruleRerun) {
                return "Immediately running the entire ruleset again may take some time, but it will allow you to see the effects of this rule in charts, tables, and CSV downloads."
              } else {
                return "Not rerunning the ruleset now means this change will not immediately be available in charts, tables, and CSV downloads. That said, this will allow you to work faster when you are developing many rules. Just rerun the rules when you would like to see the impact of all the rules."
              }
            },
            sample_title: function() {
              if (this.chart_config) {
                return "Random examples of " + this.full_filter_title
              } else {
                return ""
              }
            },
            full_filter_title: function() {
              if (this.chart_config) {
                    let title = ''
                    if (this.chart_config.field_name && this.field_value) {
                      title += this.chart_config.field_name + " = " + this.field_value
                    }
                    if (this.chart_config.color_by_field && this.sample_color_value) {
                        title += " and " + this.chart_config.color_by_field + " = " + this.sample_color_value
                    }
                    if (this.chart_config.group_by_field && this.sample_group_value) {
                        title += " and " + this.chart_config.group_by_field + " = " + this.sample_group_value
                    }
                    if (this.filter_name) {
                        title += " and with filter " + this.filter_name
                    }
                    return title
                } else {
                    return ""
                }
            },
        },
        watch: {
            version: function() {
                this.setEndPoint()
            }
        },
        methods: {
            computeFilterValues() {
                let tests = new Array()
                this.selected_filter_tests = []
                if (this.chart_config) {
                  if (this.chart_config.field_name && this.field_value) {
                    let test = {}
                    test['field'] = this.chart_config.field_name
                    test['value'] = this.field_value
                    test['operation'] = '='
                    test['enabled'] = true
                    test['human_readable'] = test['field'] + '=' + test['value']
                    tests.push(test)
                    this.selected_filter_tests.push(test['human_readable'])
                  }
                  if (this.chart_config.color_by_field && this.sample_color_value) {
                    let test = {}
                    test['field'] = this.chart_config.color_by_field
                    test['value'] = this.sample_color_value
                    test['operation'] = '='
                    test['enabled'] = true
                    test['human_readable'] = test['field'] + '=' + test['value']
                    tests.push(test)
                    this.selected_filter_tests.push(test['human_readable'])
                  }
                  if (this.chart_config.group_by_field && this.sample_group_value) {
                    let test = {}
                    test['field'] = this.chart_config.group_by_field
                    test['value'] = this.sample_group_value
                    test['operation'] = '='
                    test['enabled'] = true
                    test['human_readable'] = test['field'] + '=' + test['value']
                    tests.push(test)
                    this.selected_filter_tests.push(test['human_readable'])
                  }
                }
                if (this.asset_filter && this.asset_filter.asset_filter_tests) {
                  this.asset_filter.asset_filter_tests.forEach(test => {
                    test['enabled'] = true
                    tests.push(test)
                    this.selected_filter_tests.push(test['human_readable'])
                  })
                }
                this.filter_values = tests
            },
            setEnabledFilterTests() {
                this.filter_values.forEach(test => {
                  if (this.selected_filter_tests.indexOf(test['human_readable'])>=0) {
                    test['enabled'] = true
                  } else {
                    test['enabled'] = false
                  }
                })
            },
            drillDown() {
              this.setEnabledFilterTests()
              this.showDrilldownDialog = false
              this.show_sample_overlay = false
                if (this.drilldownHierarchy) {
                    this.drilldownGroupByField = this.drilldownSelectedHierarchy.hierarchy[0]
                    this.drilldownPrimaryField = this.drilldownSelectedHierarchy.hierarchy[1]
                    this.drilldownColorByField = this.drilldownSelectedHierarchy.hierarchy[2]
                } else {
                    this.drilldownGroupByField = false
                    this.drilldownColorByField = false
                }

              this.$emit('set_drilldown', {
                filter_values: this.filter_values,
                  group_by_field: this.drilldownGroupByField,
                primary_field: this.drilldownPrimaryField,
                  color_by_field: this.drilldownColorByField
              })

              /*
              axios.post('api/filters/add_filter_values/' + this.extent_id, {
                values:this.filter_values,
                // asset_filter_id: this.chart_config.asset_filter_id
              }).then(response => {
                // The following MUST be set at the same time!!!
                // If not, then it will load two batches back in the table view
                // (for instance, if the chart config field name is set before calling
                // the drilldown endpoint, it will first load without the asset filter (the first
                // batch) and then load again (second batch) with the asset filter)
                this.chart_config.field_name = this.drilldownPrimaryField
                this.asset_filter = response.data
                this.chart_config.asset_filter_id = response.data.id
                this.setEndPoint()
              }).catch(error => {
                console.log('oops executing drilldown')
                console.log(error.response)
              })

               */

            },
            openDrilldownDialog() {
              this.computeFilterValues()
              let depth = this.selected_filter_tests.length
              if (this.drilldownHierarchy && this.drilldownHierarchy[depth-1]) {
                  this.drilldownSelectedHierarchy = this.drilldownHierarchy[depth-1]
                  this.drilldownText = this.drilldownSelectedHierarchy.reason
              }

              this.show_sample_overlay = false
              this.showDrilldownDialog = true
            },
            openRuleDialog() {
              this.computeFilterValues()
              this.show_sample_overlay = false
              this.showRuleDialog = true
            },
            saveRule() {
              this.setEnabledFilterTests()
              // The steps:
              // 1. Add filter
              // 2. Add rule

              this.showRuleDialog = false

              axios.post('/api/rules/add/' + this.extent_id, {
                values:this.filter_values,
                bucket: this.ruleBucket,
                disposition: this.ruleDisposition,
                resourcing: this.ruleResourcing
                // asset_filter_id: this.chart_config.asset_filter_id
              }).then(response => {
                console.log('successfully added')
              }).catch(error => {
                console.log('oops executing drilldown')
                console.log(error.response)
              })

            },
            // This function is repeated in different components
            addConfig(path) {
                let blocked_attributes = ['id','created_at','updated_at']

                let new_config_params = ""

                for (const [key, value] of Object.entries(this.chart_config)) {
                    if (value !== null && !blocked_attributes.includes(key)) {
                        new_config_params += key + "=" + value + "&"
                    }
                }
                this.config_params = new_config_params
                return path + new_config_params
            },
            // Why is there both a build_parameters() and addConfig() ?
            build_parameters() {
                let params = []
                if (this.sample_color_value) params.push("color_value=" + this.sample_color_value)
                if (this.sample_group_value) params.push("group_value=" + this.sample_group_value)
                let params_as_text = "?" + this.config_params + '&' +  params.join("&")
                return params_as_text
            },
            setEndPoint() {
                if ((!this.extent_id) || (!this.chart_config)) {
                    this.endPoint = null
                } else {
                    let library = "chartjs"
                    if (this.chart_config.chart_type === "treemap" ||
                        this.chart_config.chart_type === 'sunburst' ||
                        this.chart_config.chart_type === 'icicle' ||
                        this.chart_config.chart_type === 'sitemap'
                    ) {
                        library = "d3"
                    } else if (
                        this.chart_config.chart_type === 'tableheatmap' ||
                        this.chart_config.chart_type === 'pervasiveness' ||
                        this.chart_config.chart_type === 'table_custom'
                    ) {
                        library = 'table'
                    } else if (this.chart_config.chart_type === 'big_number' || this.chart_config.chart_type === 'proportional_area') {
                        library = 'big_number'
                    } else if (this.chart_config.chart_type === 'word_cloud') {
                      library = 'word_cloud'
                    } else if (this.chart_config.chart_type === 'scatter') {
                        library = 'd3_scatter'
                    } else if (this.chart_config.chart_type === 'sankey') {
                        library = 'd3_sankey'
                    } else if (this.chart_config.chart_type === 'pie') {
                        library = 'chartjs_pie'
                    } else if (this.chart_config.chart_type === 'strip_plot') {
                      library = 'd3_strip_plot'
                    } else if (this.chart_config.chart_type === 'timeseries') {
                      library = 'chartjs_timeseries'
                    } else if (this.chart_config.chart_type === 'bump') {
                      library = 'chartjs_timeseries'
                    }
                    let profile_parameter = ""
                    if (this.profile && (library === "chartjs" || library === 'd3' || library === 'd3_scatter' || library === 'table')) {
                        profile_parameter = "/profile"
                    }
                    const endPoint = '/api/assets/field_summary/' + this.extent_id + '/' + this.chart_config.field_name + '/' + library + profile_parameter + '?'
                    this.endPoint = this.addConfig(endPoint) + 'snapshotId=' + this.snapshotId + '&version=' + this.version + (this.forced ? '&forced=true' : '');
                }
            },
            download_selection_as_csv() {
                let url = '/api/assets/sample/' + this.extent_id + '/' + this.chart_config.field_name + '/' + this.field_value + "/csv" + this.build_parameters()
                window.open(url, "_blank")
            },
            colorsLoaded(payload) {
              this.$emit('colorsLoaded',payload)
            },
            chartMetaLoaded(payload) {
              this.chartMeta = payload.meta
              if (this.chartMeta.drillDown) {
                  this.drilldownHierarchy = null
                  if (this.chartMeta.drillDown.type === 'single') {
                      this.drilldownPrimaryField = this.chartMeta.drillDown.field_name
                      this.drilldownText = this.chartMeta.drillDown.reason
                  } else if (this.chartMeta.drillDown.type === 'hierarchy') {
                      this.drilldownPrimaryField = null
                      this.drilldownText = null
                      this.drilldownHierarchy = this.chartMeta.drillDown.depth
                  } else {
                      console.log('unknown drilldown type ' + this.chartMeta.drillDown.type)
                  }
              } else {
                  this.drilldownText = 'There is no default drilldown from here. If you wish to keep the same chart but see the distribution of another field, select it.'
                  this.drilldownPrimaryField = null
              }
              if (this.chart_config.hasOwnProperty('css_id')) {
                payload.key = this.chart_config.css_id
              }
              this.$emit('chartMetaLoaded', payload)
            },
            show_label_info(payload) {
                axios.get('/api/assets/label_details/' + this.extent_id + '/' + this.chart_config.field_name + '/' + payload.label + '/' +  this.build_parameters())
                    .then(response => {
                        this.outliers = response.data
                        this.outliers_label = 'Details of ' + payload.label
                        this.show_outliers_overlay = true
                        this.field_value = payload.label
                    })
                    .catch(error => {
                        console.log('oops getting sample data')
                    })
            },
            show_stacked_sample(payload) {
                let chart_type = this.chart_config.chart_type
                let is_hierarchy_select = false
                if (chart_type==='icicle'|| chart_type==='sunburst') {
                  is_hierarchy_select = true
                }

                // for the actual sampling
                let label = payload.label

                let filter_version = []
                let filter = {}
                if (payload.hasOwnProperty('label')) {
                    let filter = {}
                    filter.field_name = this.chart_config.field_name
                    filter.field_value = payload.label
                    if (is_hierarchy_select) {
                      filter.depth = this.chartMeta.levels[this.chart_config.field_name]
                    }
                    filter_version.push(filter)
                } else {
                  label = null; // we want label to be **NULL** and not undefined if it doesn't exist
                }

                if (payload.hasOwnProperty('color')) {
                    // bar charts etc appear to be able to handle colors being "count" and the like
                    // this is a carryover from how chartjs needs the data
                    this.sample_color_value = payload.color

                    // but for icicles and others we only want color if we're really coloring
                    let useful_color = null
                    if (is_hierarchy_select) {
                      useful_color = payload.color
                    }
                    if (useful_color) {
                      filter = {}
                      filter.field_name = this.chart_config.color_by_field
                      filter.field_value = useful_color
                      if (is_hierarchy_select) {
                        filter.depth = this.chartMeta.levels[this.chart_config.color_by_field]
                      }
                      filter_version.push(filter)
                    }
                }
                if (payload.hasOwnProperty('group_value')) {
                    this.sample_group_value = payload.group_value

                    filter = {}
                    filter.field_name = this.chart_config.group_by_field
                    filter.field_value = payload.group_value
                    if (is_hierarchy_select) {
                      filter.depth = this.chartMeta.levels[this.chart_config.group_by_field]
                    }
                    filter_version.push(filter)
                }

                if (JSON.stringify(filter_version)===JSON.stringify(this.highlighted)) {
                  this.highlighted = null
                } else {
                  if (this.sticky_click) {
                    this.highlighted = filter_version
                  } else {
                    this.highlighted = null
                  }
                }

                if (this.click_callback) {
                  this.$emit(this.click_callback,this.highlighted);
                  return;
                }

                if (label === "OTHER" || this.sample_color_value === "OTHER") {
                    axios.get('/api/assets/outliers/' + this.extent_id + '/' + this.chart_config.field_name + this.build_parameters())
                        .then(response => {
                            this.outliers = response.data
                            this.outliers_label = 'OTHER'
                            this.show_outliers_overlay = true
                            this.field_value = label
                        })
                        .catch(error => {
                            console.log('oops getting sample data')
                        })
                } else {
                    axios.post('/api/assets/sample/' + this.extent_id + '/' +  this.chart_config.field_name + this.build_parameters(), {
                        additional_filters:this.additional_filters,
                        field_value: label
                    }).then(response => {
                            this.sample = response.data
                            this.show_sample_overlay = true
                            this.field_value = label
                        })
                        .catch(error => {
                            console.log('oops getting sample data')
                        })
                }
            },
            dataLoaded() {
              this.$emit('dataLoaded')
            },
            chartError(error) {
              this.$emit('chartError',error)
            },
            // This gets called when sampling from a button within a sample dialog
          show_sample(assignment_value) {
//              axios.get('/api/assignments/sample/' + this.extent_id + '/' + this.field_name + '/' + assignment_value)
              if (assignment_value === "OTHER") {
                  axios.get('/api/assets/outliers/' + this.extent_id + '/' + this.chart_config.field_name + this.build_parameters())
                      .then(response => {
                          this.outliers = response.data
                          // console.log(this.outliers)
                          this.outliers_label = 'OTHER'
                          this.show_outliers_overlay = true
                          this.field_value = assignment_value
                      })
                      .catch(error => {
                          console.log('oops getting sample data')
                      })
              } else {
                  axios.post('/api/assets/sample/' + this.extent_id + '/' + this.chart_config.field_name + this.build_parameters(), {
                    additional_filters:this.additional_filters,
                      field_value: assignment_value,
                  }).then(response => {
                          this.sample = response.data
                          this.show_sample_overlay = true
                          this.field_value = assignment_value
                      })
                      .catch(error => {
                          console.log('oops getting sample data')
                      })
              }
          }
        },
        data() {
            return {
                assignment_summaries: [],
                colors: [],
                sample: {},
                outliers: {},
                field_value: "",
                show_sample_overlay: false,
                show_outliers_overlay: false,
                showDrilldownDialog: false,
                showRuleDialog: false,
                ruleBucket: '',
                ruleDisposition: '',
                ruleResourcing: '',
                ruleRerun: false,
                asset_filter: null,
                filter_values: null,
                selected_filter_tests: [],
                sample_color_value: null,
                sample_group_value: null,
                outliers_label: 'OTHER',
                config_params: null,
                endPoint: null,
                chartMeta: [],
                drilldownGroupByField: null,
                drilldownPrimaryField: null,
                drilldownColorByField: null,
                drilldownText: "",
                drilldownHierarchy: null,
                show_bleeding_edge: false,
                highlighted: null,
            }
        }
    }

</script>